import React from 'react';
import { 
    Box,
    ClickAwayListener,
    Fade,
    Popper,
    Typography,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import GreenButton from '../buttons/GreenButton';

export default function ConfirmMASVTransferDialog(props) {
    const {
        clickAway,
        destinationBucket,
        handleClick,
        open,
        packageName,
        transferToTargetRoot,
        targetDirectoryID
    } = props;
        return (
        <Popper
            id={open ? 'warning-popper' : undefined}
            open={open}
            transition
            disablePortal
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100vw',
                height: '100vh',
                zIndex: 1300,
            }}
        >
        {({ TransitionProps }) => (
            <ClickAwayListener onClickAway={clickAway}>
                <Fade {...TransitionProps}>
                    <Box
                        width={{ xs: '95vw', sm: 500, md: 720 }}
                        minHeight={220}
                        bgcolor="rgba(20, 20, 20, 0.98)"
                        sx={{
                            border: '2px solid rgba(50, 180, 65, 1)',
                            borderRadius: 2,
                            boxShadow: 6,
                            p: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Box mb={2}>
                            <Typography color="white" variant="h6" align="center" gutterBottom>
                                {`MASV will push all ${packageName} files to the following destination:`}
                            </Typography>
                            <Typography
                                color="#b5cea8"
                                variant="body1"
                                align="center"
                                sx={{
                                    fontFamily: 'monospace',
                                    background: '#181a1f',
                                    borderRadius: 1,
                                    px: 1.5,
                                    py: 0.5,
                                    wordBreak: 'break-word',
                                    fontSize: 16,
                                    display: 'block',
                                    mx: 'auto',
                                    width: 'fit-content',
                                }}
                            >
                                {`s3://${destinationBucket}${targetDirectoryID ?? '/Portal Downloads'}/${transferToTargetRoot ? packageName : `${packageName}/${packageName}`}`}
                            </Typography>
                        </Box>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            bgcolor="rgba(200,200,0,0.08)"
                            borderRadius={1}
                            px={2}
                            py={1}
                            mb={3}
                        >
                            <WarningIcon sx={{ color: "rgba(200,200,0,0.8)", fontSize: 24, mr: 1 }} />
                            <Typography color="rgba(200,200,0,0.8)" variant="body2" align="center" sx={{ fontWeight: 500 }}>
                                By continuing, you understand the implications of this action and accept all liability associated with performing it.
                            </Typography>
                        </Box>
                        <Box display="flex" justifyContent="center">
                            <GreenButton variant="contained" onClick={handleClick} text="Continue" />
                        </Box>
                    </Box>
                </Fade>
            </ClickAwayListener>
        )}
        </Popper>
    );
}